<template>

  <div class="tw-flex tw-antialiased" ref="chatContainer">
    <div class="tw-flex tw-flex-row tw-h-full tw-overflow-x-hidden">
      <div>
        <div v-if="mensagens.length > 0"
             class="tw-flex tw-flex-col tw-flex-auto tw-flex-shrink-0 tw-rounded-md tw-bg-jrGray-50 tw-h-full tw-p-4 message-container">
          <div class="tw-flex tw-flex-col tw-h-full tw-overflow-x-auto tw-mb-4 message-max-content">
            <div class="tw-flex tw-flex-col tw-h-full">

              <div class="tw-grid tw-grid-cols-12 tw-gap-y-2">

                <!-- Mensagens -->
                <div
                  v-for="msg in mensagens.slice().sort((a, p) => p.id - a.id)"
                  :class="`tw-p-3 tw-rounded-lg ${usuario.id === msg.usuario_id ? 'tw-col-start-6 tw-col-end-13' : 'tw-col-start-1 tw-col-end-8'}`"
                >
                  <div
                    :class="`tw-flex tw-items-center ${usuario.id === msg.usuario_id ? 'tw-justify-start tw-flex-row-reverse' : 'tw-flex-row'}`">
                    <div
                      :class="`tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-rounded-full tw-flex-shrink-0 ${usuario.id === msg.usuario_id ? 'tw-bg-jrBlue-100 tw-text-white' : 'tw-shadow tw-bg-white tw-font-semibold'}`">
                      {{ getInitialsFromName(msg.nm_apelido) }}
                    </div>
                    <div
                      :class="`tw-relative tw-text-sm tw-py-2 tw-px-4 tw-shadow tw-rounded-xl ${usuario.id === msg.usuario_id ? 'tw-mr-3 tw-bg-jrBlue-25 tw-bg-opacity-50' : 'tw-ml-3 tw-bg-white' }`">
                      <div>{{ msg.nm_mensagem }}</div>
                      <div v-if="msg.nm_path" style="text-align: end">
                        <a :href="msg.nm_path_completo" target="_blank" rel="noopener noreferrer">Abrir anexo</a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <!-- Box para envio de mensagens -->
          <div class="tw-flex tw-flex-row tw-items-center tw-h-16 tw-rounded-xl tw-bg-white input-message">
            <div class="tw-flex-grow">
              <div class="tw-relative tw-w-full">
                <input type="text"
                       v-model="mensagemEnviar"
                       :placeholder="descMsg"
                       @keyup.enter="enviaMensagem"
                       class="tw-flex tw-w-full tw-rounded-xl focus:tw-border-2 focus:tw-outline-none focus:tw-border-jrBlue-25 tw-pl-4 tw-h-10 input-enviar-message"/>
              </div>
            </div>
            <div class="tw-ml-4">
              <button v-show="paramsite_chatcomprador && paramsite_chatcomprador.bn" @click="enviaMensagem"
                      class="tw-flex tw-items-center tw-justify-center tw-bg-jrBlue-100 hover:tw-bg-jrBlue-50 tw-rounded-xl tw-text-white tw-px-4 tw-py-1 tw-flex-shrink-0 send-btn-message">
                <span>Enviar</span>
                <span class="tw-ml-2">
                  <svg class="tw-w-4 tw-h-4 tw-transform tw-rotate-45 tw-mt-px" fill="none"
                       stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <span class="tw-font-bold tw-text-jrBlue-100">Mensagem da leiloeira</span>
        </div>

      </div>
    </div>
  </div>


</template>
<script>
export default {
  name: 'Mensagem',
  props: ['mensagens', 'usuario', 'paramsite_chatcomprador'],
  data() {
    return {
      mensagemEnviar: '',
      reverse: [],
      descMsg: 'Digite aqui sua mensagem...',
      loteId: this.$route.params.idlote,
    }
  },
  methods: {
    getInitialsFromName(name) {

      return name ? name.substring(0, 2).toUpperCase() : 'US';
    },
    enviaMensagem() {
      const chatContainer = this.$refs.chatContainer
      const msg = this.mensagemEnviar
      const hostName = location.protocol + "//" + window.HOSTNAME;
      if (msg != '') {
        fetch(`${hostName}/leilao/envia-mensagem`, {
          params: {
            mensagem_chat: msg,
            lote_id: this.loteId,
            origem_mensagem: 1
          }
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then(function (response) {
            if (response.erro == true) {
              alert(response.msg_erro);
              return false;
            }

            if (!response) {
              alert("Não foi possível enviar sua mensagem.");
              return false;
            }
            chatContainer.scrollTop = chatContainer.scrollHeight;
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.descMsg = 'por favor insira uma mensagem aqui...'
        this.mensagemEnviar = ''
      }

      this.mensagemEnviar = ''
    }
  }
}
</script>
<style scoped>
.input-message {
  min-width: 534px;
}

.message-container {
  max-height: 320px;
}

.message-max-content::-webkit-scrollbar {
  width: 8px;
}

.message-max-content::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 5px;
}

.message-max-content::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
}

.input-enviar-message {
  min-width: 365px !important;
}

@media (max-width: 1024px) {
  .message-container {
    max-width: 439px;
  }

  .input-message {
    max-width: 408px;
    min-width: 408px;
  }

  .send-btn-message {
    position: relative;
    right: 85px;
  }
}

@media (max-width: 768px) {
  .message-container {
    width: 328px;
    max-height: 300px;
  }

  .input-message {
    min-width: 100% !important;
  }

  .input-enviar-message {
    min-width: 158px !important;
  }

  .send-btn-message {
    right: 10px;
  }
}

@media (max-width: 435px) {
  .message-container {
    width: 342px;
    max-height: 300px;
  }
}

@media (max-width: 360px) {
  .message-container {
    width: 275px;
  }

  .input-enviar-message {
    font-size: 12px;
    font-weight: bold;
  }

  .send-btn-message {
    right: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Mensagem.vue